import { type ChangeEvent, useState } from 'react';

import { TextareaField } from '@/components/form/fields/textarea-field';
import { usePromiseCallback } from '@/hooks/use-promise-callback';

export type TaskDescriptionProps = {
  description?: string;
  onChange: (description: string) => Promise<void>;
};

export function TaskDescription({
  description,
  onChange,
}: TaskDescriptionProps) {
  const [input, setInput] = useState<string | undefined>(undefined);

  const [onSave, loading] = usePromiseCallback(
    async function (e: ChangeEvent<HTMLTextAreaElement>) {
      const value = e.currentTarget.value?.trim() ?? '';

      if (value === (description ?? '')) {
        return;
      }

      await onChange(value);
      setInput(undefined);
    },
    [onChange, setInput, description],
  );

  return (
    <TextareaField
      label="Description"
      value={input ?? description ?? ''}
      onChange={(e) => setInput(e.currentTarget.value)}
      onBlur={onSave}
      loading={loading}
    />
  );
}
